import { Helmet } from "react-helmet-async";
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { useBrand } from "@/config/brands";

const NotFound = () => {
  const location = useLocation();
  const brand = useBrand();
  const isAhp = brand.key === 'ahp';

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex items-center justify-center bg-background" style={{ minHeight: "60vh", paddingTop: 24, paddingBottom: 24 }}>
      <Helmet>
        <title>Page Not Found | {brand.name}</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      {isAhp ? (
        <div className="text-center p-12 max-w-md mx-4 rounded-lg border" style={{ backgroundColor: 'rgba(43,94,73,0.04)', borderColor: 'rgba(43,94,73,0.15)' }}>
          <div className="text-8xl font-bold mb-6" style={{ fontFamily: "'Instrument Serif', Georgia, serif", color: '#B22234' }}>404</div>
          <h1 className="mb-4 text-2xl font-bold" style={{ fontFamily: "'Instrument Serif', Georgia, serif", color: '#002868' }}>Page Not Found</h1>
          <p className="mb-6 text-muted-foreground" style={{ fontFamily: "'Instrument Sans', system-ui, sans-serif" }}>
            The page you're looking for doesn't exist or may have been moved.
          </p>
          <Link to="/near-me" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg text-white font-semibold transition-opacity hover:opacity-90" style={{ backgroundColor: '#B22234', fontFamily: "'Instrument Sans', system-ui, sans-serif" }}>
            Go to Near Me
          </Link>
        </div>
      ) : (
        <div className="text-center terminal-card p-12 max-w-md mx-4">
          <div className="text-8xl font-mono text-blood-red mb-6 glitch" data-text="404">404</div>
          <h1 className="mb-4 text-2xl font-bold text-terminal-green">System Corruption Detected</h1>
          <p className="mb-6 text-muted-foreground font-mono">
            The requested data could not be located in the healthcare database.
          </p>
          <Link to="/" className="text-primary hover:text-primary/80 font-mono underline">
            → Return to Main Terminal
          </Link>
        </div>
      )}
    </div>
  );
};

export default NotFound;
